import { documentAPI } from "api"
import copy from "fast-copy"
import { eGroupsFormat, iGroupsFormat, iRaid, options } from "typings"
import { useAuth } from "../../../context/authContext"
import { newRaidModal } from "../../../global/constants/modals"
import { useModal } from "../../../global/hooks"
import Button from "../../1_atom/buttons/button"
import RadioGroup from "../../1_atom/radio/radioGroup"
import NewRaidForm from "../modals/createRaidModal"
import { SettingSection } from "./settingSection"

const SignupsSettings = () => {
  const auth = useAuth()
  const userAPI = documentAPI().userAPI
  const [triggerModal] = useModal()

  const SignupDefaultSettings = () => {

    return (
      <div className="flex-col gap1">
        <Button
          size="mini"
          text="Show / edit my defaults"
          click={async () => {
            const modal: any = newRaidModal();
            modal.middle = (
              <NewRaidForm
                mode="edit-defaults"
                raid={auth?.userData?.settings?.signupDefaults as unknown as iRaid}
              />
            )

            triggerModal(modal)
          }}
        />
        {/* <pre style={{ color: "var(--text-color)" }}> {JSON.stringify(auth.userData.settings, null, 2)} </pre> */}
      </div>
    )
  }

  const groupsFormatOptions: options<iGroupsFormat> = [
    { label: "Clean Group Assigns", value: eGroupsFormat.CGA },
    { label: "Method Raid Tools Vertical", value: eGroupsFormat.MRT_VERTICAL }
  ]

  return (
    <>
      <SettingSection
        title="Default signup settings"
        description="Sets the default settings when trying to create a new signup."
      >
        <SignupDefaultSettings />
      </SettingSection>
      <SettingSection
        title="Groups export format"
        description="Changes the format when copying groups to paste into in-game addon."
      >
        <RadioGroup
          layout="vertical-list"
          data={{
            id: `groups-format`,
            mode: "free",
            onChange: async (value) => {
              const settings = copy(auth.userData?.settings || {})
              settings.groupsFormat = value

              await userAPI.updateMultiPath(auth.userData.userID, {
                settings
              })
            }
          }}
          options={groupsFormatOptions}
          defaultValue={auth?.userData?.settings?.groupsFormat || eGroupsFormat.CGA}
        />
      </SettingSection>
    </>
  )
}

export default SignupsSettings;